import {carrierTypes} from 'app/constant'

export const labelImageTypes = {
  png: 'PNG',
  gif: 'GIF',
  pdf: 'PDF',
  zpl: 'ZPL',
  epl: 'EPL',
}

export const upsLabelTypes = [
  {
    id: 'PAPER_LETTER',
    name: 'Paper Letter',
  },
  {
    id: 'PAPER_85X11_BOTTOM_HALF_LABEL',
    name: 'Paper 8.5x11 Bottom Half Label',
  },
  {
    id: 'PAPER_85X11_TOP_HALF_LABEL',
    name: 'Paper 8.5x11 Top Half Label',
  },
]

const upsThermalLabelTypes = [
  {
    id: 'STOCK_4X6',
    name: 'STOCK_4X6',
  },
  {
    id: 'STOCK_4X8',
    name: 'STOCK_4X8',
  },
]

export const fedExLabelTypes = [
  {
    id: 'PAPER_4X6',
    name: 'PAPER_4X6',
  },
  {
    id: 'PAPER_4X675',
    name: 'PAPER_4X6.75',
  },
  {
    id: 'PAPER_4X8',
    name: 'PAPER_4X8',
  },
  {
    id: 'PAPER_4X9',
    name: 'PAPER_4X9',
  },
  {
    id: 'PAPER_7X475',
    name: 'PAPER_7X4.75',
  },
  {
    id: 'PAPER_85X11_BOTTOM_HALF_LABEL',
    name: 'PAPER_8.5X11_BOTTOM_HALF_LABEL',
  },
  {
    id: 'PAPER_85X11_TOP_HALF_LABEL',
    name: 'PAPER_8.5X11_TOP_HALF_LABEL',
  },
  {
    id: 'PAPER_LETTER',
    name: 'PAPER_LETTER',
  },
]

export const fedExThermalLabelTypes = [
  {
    id: 'STOCK_4X6',
    name: 'STOCK_4X6',
  },
  {
    id: 'STOCK_4X675_LEADING_DOC_TAB',
    name: 'STOCK_4X675_LEADING_DOC_TAB',
  },

  {
    id: 'STOCK_4X675_TRAILING_DOC_TAB',
    name: 'STOCK_4X675_TRAILING_DOC_TAB',
  },
  {
    id: 'STOCK_4X8',
    name: 'STOCK_4X8',
  },
  {
    id: 'STOCK_4X9',
    name: 'STOCK_4X9',
  },
  {
    id: 'STOCK_4X9_LEADING_DOC_TAB',
    name: 'STOCK_4X9_LEADING_DOC_TAB',
  },

  {
    id: 'STOCK_4X9_TRAILING_DOC_TAB',
    name: 'STOCK_4X9_TRAILING_DOC_TAB',
  },
  {
    id: 'STOCK_4X85_TRAILING_DOC_TAB',
    name: 'STOCK_4X85_TRAILING_DOC_TAB',
  },
  {
    id: 'STOCK_4X105_TRAILING_DOC_TAB',
    name: 'STOCK_4X105_TRAILING_DOC_TAB',
  },
]

export const glsLabelTypes = [
  {
    id: 'PAPER_LABEL',
    name: 'PAPER_LABEL',
  },
  {
    id: 'PDF_4x5LABEL',
    name: 'PDF_4x5LABEL',
  },
]

const glsThermalLabelTypes = [
  {
    id: 'ZPL_SHORT_LABEL',
    name: 'ZPL_SHORT_LABEL',
  },
  {
    id: 'ZPL_LONG_LABEL',
    name: 'ZPL_LONG_LABEL',
  },
  {
    id: 'ZPL_SHORT_LABEL_PON',
    name: 'ZPL_SHORT_LABEL_PON',
  },
  {
    id: 'ZPL_LONG_LABEL_PON',
    name: 'ZPL_LONG_LABEL_PON',
  },
]

export const getShippingLabelTypes = (carrierType: string) => {
  if (!carrierType) {
    return []
  }
  if (carrierType.toLowerCase() === carrierTypes.FEDEX.toLowerCase()) {
    return {
      imageTypes: fedExLabelImageTypeList,
      labelTypes: fedExLabelTypes,
      thermalLabelTypes: fedExThermalLabelTypes,
    }
  } else if (carrierType.toLowerCase() === carrierTypes.GLS.toLowerCase()) {
    return {
      imageTypes: glsLabelImageTypeList,
      labelTypes: glsLabelTypes,
      thermalLabelTypes: glsThermalLabelTypes,
    }
  } else {
    return {
      labelTypes: upsLabelTypes,
      imageTypes: upsLabelImageTypeList,
      thermalLabelTypes: upsThermalLabelTypes,
    }
  }
}

const fedExLabelImageTypeList = [
  labelImageTypes.png,
  labelImageTypes.pdf,
  labelImageTypes.zpl,
  labelImageTypes.epl,
]

const upsLabelImageTypeList = [
  labelImageTypes.png,
  labelImageTypes.gif,
  labelImageTypes.pdf,
  labelImageTypes.zpl,
  labelImageTypes.epl,
]

const glsLabelImageTypeList = [labelImageTypes.png, labelImageTypes.pdf, labelImageTypes.zpl]
